import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Button, Stack, Tooltip} from "@mui/material";
import {Cached, Delete} from "@mui/icons-material";
import MaterialEstimateUnitService
    from "../../../../../../API/orders/estimate/organization/MaterialEstimateUnitService";
import {
    ESTIMATE_GLOBAL_FILTER_FN,
    estimateFilterFns,
    estimateGetColumnCanGlobalFilter,
    filterEstimateRowsByGlobalSearch,
    getMaterialEstimateArticle,
    getMaterialEstimateName,
    sortMaterialEstimateByCatalogArticle,
    sortMaterialEstimateByCatalogName,
} from "../../../../../../utils/orders/estimateTableFilter";

const MaterialCostTable = ({
                               materialEstimateUnits,
                               setMaterialEstimateUnits,
                               currency,
                               currentCurrency,
                               orderId, orderNumber, orderHeaderId, year, isButtonPurchase,
                               isActual, enableEditing, inWork,
                               tableOptions,
                               tableOptionsHandle
                           }) => {

    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [materialPriceUnits, setMaterialPriceUnits] = useState(new Map());
    const [rowSelection, setRowSelection] = useState({});

    const [setPurchaseModalOpen, setSetPurchaseModalOpen] = useState(false);
    const [change, setChange] = useState(false);
    const [currentInWork, setCurrentInWork] = useState(inWork);

    const [searchSimilarMaterials, setSearchSimilarMaterials] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');

    const filteredMaterialEstimateUnits = useMemo(
        () => filterEstimateRowsByGlobalSearch(materialEstimateUnits, globalFilter),
        [materialEstimateUnits, globalFilter],
    );

    const sumAmountBasePrice = useMemo(
        () => materialEstimateUnits.reduce((acc, mEU) => {
            if (mEU.basePrice !== null) {
                return acc + mEU.basePrice.price;
            } else {
                return acc;
            }
        }, 0),
        [materialEstimateUnits]
    );

    const sumAmountAlternativePrice = useMemo(
        () => materialEstimateUnits.reduce((acc, mEU) => {
            if (mEU.alternativePrice !== null) {
                return acc + mEU.alternativePrice.price;
            } else {
                return acc;
            }
        }, 0),
        [materialEstimateUnits]
    );

    const handleDeleteRow = useCallback(
        (row) => {
            const id = row.original.id;
            const materialId = row.original.id
            MaterialEstimateUnitService.delete(id)
                .then(function () {
                    materialEstimateUnits.splice(row.index, 1);
                    setMaterialEstimateUnits([...materialEstimateUnits]);
                    materialPriceUnits.delete(materialId);
                })
                .catch(function (error) {
                    console.log(error);
                })
        },
        [materialEstimateUnits],
    );

    /*    const handleSubmitSetPurchase = async () => {
            EstimateService.setPurchase(estimateId)
                .then(function () {
                    handleCloseSetPurchase()
                    setCurrentInWork(false);
                })
                .catch(function (error) {
                    console.log(error);
                })
        }*/

    const handleCloseSetPurchase = () => {
        setSetPurchaseModalOpen(false);
    };

    const openSearchSimilarMaterials = useCallback(
        (row) => {
            setCurrentEditRowData(row.original);
            setSearchSimilarMaterials(true)
        },
        [],
    );

    const materialReplacement = () => {
        setSetPurchaseModalOpen(false);
    };

    const selectInMaterialOOId = async (row) => {
        const id = currentEditRowData.id
        MaterialEstimateUnitService.replacementByMaterialOrganizationOptionId(id, row.original.id)
            .then(function () {
                setChange(!change)
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    const selectInMaterialId = async (row) => {
        const id = currentEditRowData.id
        MaterialEstimateUnitService.replacementByMaterialId(id, row.original.id)
            .then(function () {
                setChange(!change)
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    const columns = useMemo(
        () => [
            {
                id: 'articleNumber',
                header: 'Артикул',
                accessorFn: getMaterialEstimateArticle,
                sortingFn: sortMaterialEstimateByCatalogArticle,
                minSize: 15,
                maxSize: 25,
                Cell: ({row, renderedCellValue}) => {
                    return (row.original.materialOrganizationOption !== null) ? renderedCellValue : '';
                }
            },
            {
                id: 'name',
                header: 'Наименование',
                accessorFn: getMaterialEstimateName,
                sortingFn: sortMaterialEstimateByCatalogName,
                minSize: 50,
                maxSize: 50,
                enableEditing: false,
                Cell: ({row, renderedCellValue}) => {
                    const temp = row.original.materialOrganizationOption === null;
                    return (
                        <span
                            style={{
                                color: temp ? 'red' : 'black'
                            }}>
                               {renderedCellValue}
                            </span>
                    );
                }
            },
            {
                id: 'unit.name',
                header: 'Ед. изм.',
                accessorFn: (row) => {
                    if (row.materialOrganizationOption !== null) {
                        return row.unit ? row.unit.name : 'Нет данных';
                    } else {
                        return row.tempUnit ? row.tempUnit.name : 'Нет данных';
                    }
                },
                minSize: 5,
                maxSize: 5,
            },
            {
                id: 'quantity',
                header: 'Кол.',
                accessorKey: 'quantity',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
                },
            },
            {
                id: 'basePrice',
                header: `Стоимость ${currency[0].value}`,
                accessorKey: 'basePrice',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.price.toFixed(2)
                },
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumAmountBasePrice?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                            })} {currency[0].value}
                        </Box>
                    </Stack>
                ),
            },
            {
                id: 'alternativePrice',
                header: `Стоимость ${currency[1].value}`,
                accessorKey: 'alternativePrice',
                minSize: 15,
                maxSize: 15,
                Cell: ({cell, row}) => {
                    const value = cell.getValue();
                    return value === null || value === undefined ? 'Ожидание' : value.price.toFixed(2)
                },
                Footer: () => (
                    <Stack>
                        <Box color="warning.main">
                            {sumAmountAlternativePrice?.toLocaleString?.('en-US', {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 2,
                            })} {currency[1].value}
                        </Box>
                    </Stack>
                ),
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableColumnActions: false,
                enableGrouping: false,
                enableEditing: false,
                size: 2,
            },
        ],
        [materialEstimateUnits, setMaterialEstimateUnits],
    );

    return (
        <div>
            <MaterialReactTable
                renderTopToolbar={({table}) => {
                    return <Box sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "7px",
                        backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                    }}>
                        <MRT_ToolbarAlertBanner table={table}/>
                        <Box sx={{display: "flex"}}>
                            <MRT_ToggleFiltersButton table={table}/>
                            <MRT_GlobalFilterTextField table={table}/>
                        </Box>
                    </Box>
                }}
                selectAllMode={"all"}
                muiTableBodyCellProps={{
                    sx: {
                        p: '0px 0px 0px 10px',
                        m: '0px 0px 0px 0px',
                        border: "none",
                        "&:after": {
                            display: "none",
                        },
                        "& td:after": {
                            "&:hover": {
                                backgroundColor: "red"
                            }
                        },
                        "&:not(:last-of-type)": {
                            borderRight: '1px solid #EAEBEA',

                        },
                        /*   "&:first-of-type": {
                               padding: 0,
                               width: "100%",
                               height: "36px",
                               display: "flex",
                               justifyContent: "center",
                               alignItems: "center",
                               color: (theme) => theme.palette.text.light,
                               "& .MuiButtonBase-root": {
                                   borderRadius: "4px",
                                   width: "24px",
                                   height: "24px",
                                   opacity: 1,
                                   margin: 0,
                                   padding: 0,
                                   "&:hover": {
                                       backgroundColor: (theme) => theme.palette.primary.stroke,
                                   }
                               }
                           },*/
                        "& li": {
                            listStyleType: "none",
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }
                            }
                        }
                    },
                }}
                muiTableHeadCellProps={{
                    sx: {
                        border: '1px solid #EAEBEA',
                        backgroundColor: "#F5F6FA",
                        padding: "10px",
                        paddingBottom: " 0.2rem",
                        paddingTop: "0.2rem"
                    },
                }}
                muiTableBodyRowProps={({row}) => {
                    return ({
                        sx: () => ({
                            height: '36px',
                            backgroundColor: "white",
                            "&:hover& td:after": {
                                display: "none",
                            },
                            "&.MuiTableRow-root.Mui-selected": {
                                backgroundColor: (theme) => theme.palette.primary.light70,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.light50,
                                },
                            },
                            "&:hover": {
                                "& td:after": {
                                    display: "none",
                                },
                                backgroundColor: (theme) => theme.palette.primary.stroke,
                            },
                            '&:nth-of-type(even)': {
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                "&:hover": {
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                            },
                        })
                    })
                }}

                displayColumnDefOptions={{
                    'mrt-row-actions': {
                        header: "",
                        size: 10,
                        grow: false,
                    },
                    'mrt-row-select': {
                        size: 10,
                        grow: false,
                    },
                }}
                muiSearchTextFieldProps={{
                    placeholder: `Поиск`,
                    sx: {
                        paddingTop: "5px",
                        paddingBottom: "0px",
                        "& .MuiCollapse-root": {
                            borderRadius: '12px',
                            height: 40, width: 290,
                            "& .MuiSvgIcon-root": {
                                color: "#737478"
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: 0
                            }
                        }
                    },
                    variant: 'outlined',
                }}
                columns={columns}
                data={filteredMaterialEstimateUnits}
                rowHeight={13}
                columnSpacing={1}
                initialState={{
                    columnVisibility: {
                        id: false,
                        calculationAmountAlternativePrice: false

                    },
                    isFullScreen: false,
                    density: "compact",
                    pagination: {pageIndex: 0, pageSize: 50},
                    showGlobalFilter: true,
                }}
                enableEditing={false}
                onRowSelectionChange={setRowSelection}
                onPaginationChange={(updater) => {
                    tableOptionsHandle(updater(tableOptions));
                }}
                onGlobalFilterChange={setGlobalFilter}
                globalFilterFn={ESTIMATE_GLOBAL_FILTER_FN}
                filterFns={estimateFilterFns}
                getColumnCanGlobalFilter={estimateGetColumnCanGlobalFilter}
                enableGlobalFilterRankedResults={false}
                state={{rowSelection, showGlobalFilter: true, pagination: tableOptions, globalFilter}}
                rowCount={filteredMaterialEstimateUnits.length}
                enableRowSelection={false}
                getRowId={(originalRow) => originalRow.id}
                selectionPadding={1}
                selectionCss={{
                    backgroundColor: 'lightblue',
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: 'blue',
                    borderRadius: '4px',
                }}
                renderRowActions={({row, table}) => (
                    <Box sx={{
                        display: 'flex',
                        gap: '0.1rem',
                        justifyContent: 'flex-start',
                        maxWidth: '50px'
                    }}>
                        {!row.original.isBlocked ?
                            <Tooltip arrow placement="left" title="Заменить">
                                <Button size="small" sx={{minWidth: 'auto', marginLeft: 'auto'}} color="pencil"
                                        onClick={() => openSearchSimilarMaterials(row)}>
                                    <Cached sx={{minWidth: 'auto', marginLeft: 'auto', fontSize: 20}}/>
                                </Button>
                            </Tooltip> : <Button size="small" sx={{minWidth: 'auto', marginLeft: 'auto'}} color="pencil"
                                                 onClick={() => openSearchSimilarMaterials(row)}>
                                <Cached sx={{minWidth: 'auto', marginLeft: 'auto', fontSize: 20}}/>
                            </Button>
                        }
                        {!row.original.isBlocked ? <Tooltip arrow placement="right" title="Удалить">
                            <Button
                                size="small"
                                sx={{minWidth: 'auto', marginLeft: 'auto'}}
                                color="error"
                                onClick={() => handleDeleteRow(row)}
                            >
                                <Delete sx={{minWidth: 'auto', marginLeft: 'auto', fontSize: 20}}/>
                            </Button>
                        </Tooltip> : <Button
                            size="small"
                            sx={{minWidth: 'auto', marginLeft: 'auto'}}
                            color="error"
                            onClick={() => handleDeleteRow(row)}
                            disabled={true}
                        >
                            <Delete sx={{minWidth: 'auto', marginLeft: 'auto', fontSize: 20}}/>
                        </Button>}
                    </Box>
                )}
                muiTableContainerProps={{
                    sx: {
                        maxHeight: `calc(100vh - 600px)`,
                    }
                }}
                localization={MRT_Localization_RU}
                enableToolbarInternalActions={false}
                renderTopToolbarCustomActions={({table}) => {
                    const setCurrency = (typeCurrentCurrency) => {
                    };

                    return (
                        <div>
                            <Box
                                sx={{
                                    display: 'flex',
                                    gap: '0.5rem',
                                    paddingLeft: '0.5rem',
                                    paddingTop: '0.5rem',
                                    paddingBottom: '0.2rem',
                                    flexWrap: 'wrap',
                                }}
                            >
                            </Box>
                            <Box
                                sx={{display: 'flex', gap: '0.5rem', p: '0.5rem', flexWrap: 'wrap'}}
                            >
                                {/*{isButtonPurchase === 'true' && <Button
                                    size="small"
                                    color="success"
                                    onClick={() => setSetPurchaseModalOpen(true)}
                                    variant="contained"
                                    disabled={!currentInWork}
                                >
                                    Подать заявку на закупку
                                </Button>}*/}
                            </Box>
                        </div>
                    );
                }}
            />
            {/*    <ModalConfirm
                title={"Подтвердить создание заявки на закупку?"}
                modalOpen={setPurchaseModalOpen}
                handleClose={handleCloseSetPurchase}
                handleSubmit={handleSubmitSetPurchase}
                action={"Подтвердить"}
            />*/}
        </div>
    );
};

export default MaterialCostTable;

